// Setting up vars to be used throughout
let active = 'active'

// Tabs and page content sections
let tabs = document.querySelectorAll('.blog-nav > a')
let contents = document.querySelectorAll('.article-template__content > .article-content__tab')

let navEl = document.querySelector('.blog-nav-outer')
let navElOffset;

if(navEl) {
  // Calculating sticky nav height and position.
  navElOffset = navEl.offsetTop - navEl.offsetHeight;
}

let headerHeight = 0;

// Scrolls to original top nav position, respecting header height.
scrollToContent = () => {
  let addtlOffset = 0;

  if(getNetNavOffset() <= headerHeight) addtlOffset = headerHeight;

  scroll({
    top: navElOffset - addtlOffset,
    behavior: "smooth"
  })
}

// Resets display by hiding tabs
hideTabs = () => {
  for( let content of contents ) {
    content.classList.remove(active)
  }

  for( let tab of tabs ) {
    tab.classList.remove(active)
  }
}

showTabByName = (tabName) => {
  let contentToShow = document.querySelector(`.article-content__tab[data-tab="${ tabName }"]`);
  contentToShow.classList.add(active);
}

getNetNavOffset = () => {
  return navEl.offsetTop - getScrollPosition();
}

calculateHeaderHeight = () => {
  let headerEl = document.querySelector('header.header')
  headerHeight = headerEl.offsetHeight;
}

getScrollPosition = () => {
  return document.documentElement.scrollTop || document.body.scrollTop;
}

recalculateScrollNavPos = () => {
  calculateHeaderHeight();

  // Temporarily sets position of nav to relative to recalculate position.
  navEl.style.position = 'relative'  
  navElOffset = navEl.offsetTop - navEl.offsetHeight;

  window.setTimeout(() => {
    navEl.style.position = 'sticky'
  }, 1)
}

setupTabClicks = () => {
  for( let tab of tabs ) {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
  
      hideTabs();
      showTabByName(tab.getAttribute('href').replace('#',''));
      tab.classList.add(active)
      //scrollToContent();
    })
  }
}

displayInitialTab = (hash) => {
  let correspondingAnchor = document.querySelector(`.blog-nav > a[href="${hash}"]`)

  if(correspondingAnchor) {
    hideTabs()
    showTabByName(hash.replace('#',''))
  }
}

if(navEl) {
  recalculateScrollNavPos();
  // Entry point of this code
  // Setting up listeners for style calculation and click events.
  setupTabClicks()
  window.addEventListener('scroll', calculateHeaderHeight)
  window.addEventListener('resize', recalculateScrollNavPos)

  displayInitialTab(window.location.hash)
}
